"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataStorageManager = void 0;
var expired_storage_1 = __importDefault(require("expired-storage"));
var BackupStorage_1 = require("./BackupStorage");
var utils_1 = require("./utils");
var DataStorageManager = /** @class */ (function () {
    function DataStorageManager(_a) {
        var ttl = _a.ttl;
        this._ttl = ttl || DataStorageManager.DEFAULT_TTL;
        if (utils_1.isLocalStorageSupported())
            this._storage = new expired_storage_1.default();
        else {
            this._storage = new expired_storage_1.default(BackupStorage_1.BackupStorage);
        }
    }
    DataStorageManager.prototype.set = function (key, value) {
        this._storage.setItem(key, value, this._ttl);
    };
    DataStorageManager.prototype.get = function (key) {
        return this._storage.getItem(key);
    };
    DataStorageManager.prototype.getTimeLeft = function (key) {
        return this._storage.getTimeLeft(key);
    };
    DataStorageManager.prototype.clearExpired = function () {
        this._storage.clearExpired();
    };
    DataStorageManager.prototype.clear = function (key) {
        this._storage.removeItem(key);
    };
    DataStorageManager.DEFAULT_TTL = 600;
    return DataStorageManager;
}());
exports.DataStorageManager = DataStorageManager;
//# sourceMappingURL=DataStorageManager.js.map